import {Component, OnInit, Input} from '@angular/core';
import {MessageService} from 'src/app/services/message.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
  @Input() show: boolean;
  @Input() position: string;
  @Input() type: string;

  showPopupMessage: boolean;
  message: string;
  subscription: Subscription;
  popupSubscription: Subscription;

  constructor(private messageService: MessageService) {
  }

  ngOnInit() {
    if (this.position === 'popup') {
      this.popupSubscription = this.messageService.showPopupMessage$.subscribe(
        status => {
          if (status) {
            this.show = true;
            this.message = this.messageService.message;
          } else {
            this.show = false;
          }
        }
      );
    } else {
      this.subscription = this.messageService.showMessage$.subscribe(status => {
        if (status) {
          this.show = true;
          this.message = this.messageService.message;
          this.type = this.messageService.type;
        } else {
          this.show = false;
        }
      });
    }
  }
}
